import Marquee from "./Marquee";
import { colleges, courseCount } from "../data/colleges";

/* ---------------------------------------------------------------------------
   The strip under the header: admissions news, then every course we run,
   scrolling past. It sits on every page, so wherever you land the site is
   already moving and the whole catalogue has walked past you once.

   Each item carries its college's spectrum colour as a dot — four colours,
   always in the same order, never restyling the page around them.
--------------------------------------------------------------------------- */

const items = [
  { text: <><strong>Admissions open</strong> for 2026–27</>, slug: "management" },
  { text: <>{courseCount} courses across four colleges</>, slug: "medical" },
  ...colleges.flatMap((c) =>
    c.courses.map((course) => ({
      text: (
        <>
          {course.name} · {course.duration}
        </>
      ),
      slug: c.slug,
    }))
  ),
  {
    text: (
      <>
        Recognised by INC · PNRC · Guru Nanak Dev University · Baba Farid
        University of Health Sciences · I.K Gujral Punjab Technical University
      </>
    ),
    slug: "law",
  },
];

const NewsBar = () => (
  <div className="newsbar">
    <Marquee speed="slow">
      {items.map((item, i) => (
        <span
          className="newsbar-item"
          key={i}
          style={{ "--dot": `var(--v-${item.slug}-lift)` }}
        >
          <span className="newsbar-dot" aria-hidden="true" />
          {item.text}
        </span>
      ))}
    </Marquee>
    <div className="ribbon" aria-hidden="true" />
  </div>
);

export default NewsBar;
